var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"employee-card",class:{ 'ma-0': _vm.noSpacing }},[_c('v-row',{staticClass:"pa-0 ma-0"},[_c('v-col',{staticClass:"pa-0 ma-0"},[_vm._v(" "+_vm._s(_vm.employee.name)+" "),_c('p',{staticClass:"categories"},[_vm._v(" "+_vm._s(_vm.getCatNames(_vm.employee.categories))+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }